import Wrapper from 'components/reusables/wrapper'
import ExternalCourses from './components/externalCourses'

const ExternalCoursesAdministration: React.FC = () => {
  return (
    <Wrapper shadow={true}>
      <ExternalCourses />
    </Wrapper>
  )
}

export default ExternalCoursesAdministration
